import { render, staticRenderFns } from "./BoardingCompliance.vue?vue&type=template&id=6e1e743e&scoped=true&"
import script from "./BoardingCompliance.vue?vue&type=script&lang=js&"
export * from "./BoardingCompliance.vue?vue&type=script&lang=js&"
import style0 from "./BoardingCompliance.vue?vue&type=style&index=0&id=6e1e743e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1e743e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e1e743e')) {
      api.createRecord('6e1e743e', component.options)
    } else {
      api.reload('6e1e743e', component.options)
    }
    module.hot.accept("./BoardingCompliance.vue?vue&type=template&id=6e1e743e&scoped=true&", function () {
      api.rerender('6e1e743e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/checklist/BoardingCompliance.vue"
export default component.exports